<template>
  <modal
    name="vipTrialModal"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
    :classes="['custom']"
    :clickToClose="false"
    :width="636"
    :height="'auto'"
    :min-height="400"
  >
    <div class="container">
      <div class="title">
        <div class="title-text">
          你好，{{UserMsg.nickname}}，欢迎使用来画动画
        </div>
      </div>
      <div class="text-main">
        <div class="text-main-item">为了您更好的创作体验，我们已赠送您<span class="strong">24小时</span>的个人会员体验版。</div>
        <div class="text-main-item">有效期内您可以<span class="strong">免费</span>体验下列会员专属功能：  </div>
      </div>
      <div class="panes">
        <div class="pane" v-for="pane, i in panes" :key="i">
          <div class="figure" :class="[pane.value]"></div>
          <div class="text">{{pane.text}}</div>
        </div>
      </div>
      <div class="text-short">创作首个作品并导出，将再获得个人会员体验版24小时。</div>
      <div class="buttons">
        <div class="btn" @click="showAnimCourse">新手入门指引</div>
        <div class="btn colored" @click="startEdit">开始创作</div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex'; 
export default {
  data () {
    return {
      panes: [
        {text: '会员专属素材', value: 'vipResource'},
        {text: '智能AI配音', value: 'smartVoice'},
        {text: '视频不限时长', value: 'duration'},
        {text: '无限720P导出', value: 'resolution'}
      ]
    }
  },
  computed: {
    ...mapGetters([
      'UserMsg'
    ])
  },
  created () {

  },
  methods: {
    showAnimCourse () {
      sensors.track('newCreateUserGuide');
      this.clickToClose();
      this.$bus.emit("getApiCourse");
      this.$store.commit("save_TopnavMsg", {
        isShowAnimCourseDialog: true,
      });
    },
    startEdit () {
      sensors.track('newCreateStartGuide');
      this.clickToClose();
      this.$store.commit('helpCenter/setEntryGuideShown', true);
    },
    clickToClose () {
      this.$modal.hide('vipTrialModal');
    },
    beforeOpen ({ params } = {}) {

    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  margin: auto;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  text-align: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(../../../assets/vipTrialMessage/bg.png);
}
.title {
  width: 100%;
  padding-left: 42px;
  padding-right: 42px;
  padding-top: 50px;
  margin-bottom: 18px;
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  text-align: left;
  .title-text {
    position: relative;
    display: inline-block;
    &::after {
      content: ' ';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 10px;
      background-color: #FBA457;
      opacity: 0.18;
    }
  }
}
.text-main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 49px;
  padding-left: 42px;
  padding-right: 42px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  .strong {
    color: #113DF5;
    font-size: 16px;
    font-weight: bold;
    padding-left: 10px;
    padding-right: 10px;
  }
}
.panes {
  display: flex;
  justify-content: center;
  padding-top: 18px;
  padding-bottom: 20px;
  .pane {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 128px;
    height: 109px;
    background: linear-gradient(180deg, #FEF1EB 0%, #FFFFFF 100%);
    box-shadow: 0px 3px 6px rgba(113,56,12,0.1200);
    opacity: 1;
    border-radius: 4px;
    margin-left: 8px;
    margin-right: 8px;
    .figure {
      width: 46px;
      height: 46px;
      margin-bottom: 12px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      &.vipResource {
        background-image: url(../../../assets/vipTrialMessage/vipResource.png);
      }
      &.smartVoice {
        background-image: url(../../../assets/vipTrialMessage/smartVoice.png);
      }
      &.duration {
        background-image: url(../../../assets/vipTrialMessage/duration.png);
      }
      &.resolution {
        background-image: url(../../../assets/vipTrialMessage/resolution.png);
      }
    }
  }
}
.text-short {
  width: 100%;
  padding-left: 42px;
  padding-right: 42px;
  text-align: left;
}
.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 28px;
  padding-bottom: 24px;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 126px;
    height: 40px;
    margin-left: 10px;
    margin-right: 10px;
    background: #FFFFFF;
    border: 1px solid #D1D4DD;
    opacity: 1;
    border-radius: 4px;
    &.colored {
      background-color: #5778FB;
      border-color: #5778FB;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/vipTrialMessage/vipTrialModal.vue